<template>
    <SectionText class="loading-section" v-if="isShown">
        <template v-slot:custom>
            <LoadingSpinner v-if="isLoading"></LoadingSpinner>
            <AlertError :alert="error" v-if="isError"></AlertError>
        </template>
    </SectionText>
</template>

<script>
export default {
    name: 'LoadingSection',
    props: ['loading', 'error'],
    computed: {
        isShown () {
            return this.isLoading || this.isError;
        },
        isLoading () {
            return this.loading && !this.error;
        },
        isError () {
            return !!this.error;
        },
    },
};
</script>
